import React from "react";
import { Col, Row, ProgressBar } from "react-bootstrap";
import {
  GraphicProjectWorker,
  GraphicProjectPlanner,
  GraphicUserPanel,
  GraphicProjectCalendar,
} from "../../../components/GraphicSPV.component";
import Jumbotron from "../../../components/Jumbotron.component";
import { FaUserAlt, FaTasks } from "react-icons/fa";
import { GoProject } from "react-icons/go";
import SEO from "../../SEO";
import { useQuery } from "@apollo/client";
import {
  GET_PROJECT_SUPERVISOR,
  GET_TASK_SUPERVISOR,
  GET_USER_FROM_ADMIN,
} from "../../../graphql/queries";
import { LinearProgress } from "@material-ui/core";
import { connect } from "react-redux";
import ReactPaginate from 'react-paginate'
import {setCurrentPage, setOffPage} from '../../../redux/actions/spvAction'

const MainDashboard = ({postsPerPage, offset, setCurrentPage, setOffPage}) => {
  const cardStyle = {
    fontSize: "1.75rem",
    color: "gray",
    display: "flex",
    justifyContent: "center",
  };

  let newArrTask = [];
  let newArrProject = [];

  const { data: userData, loading: userLoading, error: userError } = useQuery(
    GET_USER_FROM_ADMIN
  );
  const {
    data: projectData,
    loading: projectLoading,
    error: projectError,
  } = useQuery(GET_PROJECT_SUPERVISOR, { pollInterval: 1000 }); 
  const {
    data: taskData,
    loading: taskLoading,
    error: taskError,
  } = useQuery(GET_TASK_SUPERVISOR, { pollInterval: 1000 });

  if (userLoading) return <LinearProgress />;
  if (projectLoading) return <LinearProgress />;
  if (taskLoading) return <LinearProgress />;

  const totalUsers = userData.findAllUser.filter(
    ({ role }) => role === "planner" || role === "worker"
  );
  const totalProjects = projectData.findAllProjectSupervisor.filter(
    ({ status }) =>
      status === "approve" ||
      status === "return" ||
      status === "submit" ||
      status === "reject" ||
      status === "done" ||
      status === "return to worker" ||
      status === "complete"
  );
  const totalTasks = taskData.findAllTaskSupervisor.length;

  taskData.findAllTaskSupervisor
    .slice()
    .sort(
      ({ project_id: previousID }, { project_id: currentID }) =>
        previousID - currentID
    )
    .map((o) => {
      return newArrTask.push(o);
    });

  projectData.findAllProjectSupervisor
    .slice()
    .sort(({ id: previousID }, { id: currentID }) => previousID - currentID)
    .map((o) => {
      return newArrProject.push(o);
    });

  let filteredTaskList = newArrProject.map((item) => {
    let joinedArr = newArrTask.filter((o) => o.project_id === item.id);
    return { ...item, taskList: [...joinedArr] };
  });

  console.log(filteredTaskList);

  // GET CURRENT POSTS

  // const currentPosts = filteredTaskList.slice(offset, offset + postsPerPage);

  // const pageNumbers = Math.ceil(filteredTaskList.length / postsPerPage);

  // const handlePageClick = (e) => {
  //   const selectedPage = e.selected;

  //   const offset = selectedPage * postsPerPage;

  //   setCurrentPage(selectedPage);
  //   setOffPage(offset);
  // };

  // const secondColumnStart = Math.floor(filteredTaskList.length / 2);

  const isChecked = filteredTaskList
    .filter(
      ({ status }) =>
        status === "approve" ||
        status === "done" ||
        status === "complete" ||
        status === "submit" ||
        status === "return" ||
        status === "return to worker"
    )
    .map(({ id, title, taskList, status }, key) => {
      const taskListFiltered = taskList.filter(
        ({ is_check }) => is_check == "true"
      ).length;
      const now = Math.floor((taskListFiltered / taskList.length) * 100);

      return (
        <div key={key} className="tasklist-list my-3">
          <div className="d-flex my-3 justify-content-between align-items-center">
            <span>
              <strong>
                {id}. {title}
              </strong>
              {"  "}
            </span>
            <span
              className={`align-self-end py-1 px-2 text-capitalize ${
                status === "approve" || status === "done"
                  ? "bg-success text-white text-center"
                  : status === "complete"
                  ? "bg-info text-white text-center"
                  : status === "reject"
                  ? "bg-danger text-white text-center"
                  : status === "submit"
                  ? "bg-primary text-white text-center"
                  : "bg-warning text-white text-center"
              }`}
            >
              <strong>Status: {status}</strong>
              {"  "}
            </span>
          </div>
          <ProgressBar
            animated
            now={now || 0}
            min={0}
            variant={now == 100 ? "success" : "primary"}
            label={`${now}%`}
          />
        </div>
      );
    });

  // const mappingTask = newArrTask.map(({}))

  return (
    <div style={{ maxWidth: "1920px", margin: "0 auto", overflow: "hidden" }}>
      <SEO
        title="Supervisor"
        description="Main Dashboard"
        content="Main Dashboard"
      />
      <Jumbotron
        notPlanner={true}
        description={"This menu is for main menu dashboard"}
      />
      <Row className="d-flex justify-content-center">
        <Col lg={3} md={3} sm={6} className="card-border m-5 px-4">
          <Row className="d-flex align-items-center">
            <Col lg={9} md={9} sm={9} xs={9} className="my-3">
              <span className="font-weight-bold text-primary">
                Total Users{" "}
              </span>
              <br />
              <span className="font-weight-bold">{totalUsers.length}</span>
            </Col>
            <Col lg={3} md={3} sm={3} xs={3}>
              <FaUserAlt style={cardStyle} />
            </Col>
          </Row>
        </Col>
        <Col lg={3} md={3} sm={6} className="card-border m-5 px-4">
          <Row className="d-flex align-items-center">
            <Col lg={9} md={9} sm={9} xs={9} className="my-3">
              <span className="font-weight-bold text-primary">
                Total Projects{" "}
              </span>
              <br />
              <span className="font-weight-bold">{totalProjects.length}</span>
            </Col>
            <Col lg={3} md={3} sm={3} xs={3}>
              <GoProject style={cardStyle} />
            </Col>
          </Row>
        </Col>
        <Col lg={3} md={3} sm={6} className="card-border m-5 px-4">
          <Row className="d-flex align-items-center">
            <Col lg={9} md={9} sm={9} xs={9} className="my-3">
              <span className="font-weight-bold text-primary">
                Total Tasks{" "}
              </span>
              <br />
              <span className="font-weight-bold">{totalTasks}</span>
            </Col>
            <Col lg={3} md={3} sm={3} xs={3}>
              <FaTasks style={cardStyle} />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="d-flex justify-content-center">
        <Col lg={4} md={11} sm={11} xs={11}>
          <div className="graph-border my-3" style={{ height: "500px" }}>
            <h5 className="text-center font-weight-bold text-primary">
              Total User Types
            </h5>
            <GraphicUserPanel />
          </div>
        </Col>
        <Col lg={7} md={11} sm={11} xs={11}>
          <div className="graph-border my-3" style={{ height: "500px" }}>
            <h5 className="text-center font-weight-bold text-primary">
              Total Status Progress Projects
            </h5>
            <GraphicProjectPlanner />
          </div>
        </Col>
      </Row>

      <Row className="d-flex justify-content-center mt-5">
        <Col lg={11} md={11} sm={11} xs={11}>
          <div className="graph-border" style={{ height: "500px" }}>
            <h5 className="text-center font-weight-bold text-primary">
              Timeline Project
            </h5>
            <GraphicProjectCalendar />
          </div>
        </Col>
      </Row>
      <Row className="d-flex justify-content-center mt-5">
        <Col lg={11} md={11} sm={11} xs={11}>
          <div className="tasklist-progress">
            <h5 className="text-center font-weight-bold text-primary">
              Total Progress Task List in Projects
            </h5>
            <Row lg={2} md={1} sm={1} xs={1} className="d-flex flex-row">{isChecked}</Row>
            {/* <Col className="d-flex justify-content-center align-items-center"> */}
              {/* <ReactPaginate
                previousLabel={"prev"}
                nextLabel={"next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={pageNumbers}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              /> */}
            {/* </Col> */}
          </div>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    // currentPage: state.spv.pagination.currentPage,
    // postsPerPage: state.spv.pagination.postsPerPage,
    // offset: state.spv.pagination.offset,
  }
}

export default connect(mapStateToProps, {setCurrentPage, setOffPage})(MainDashboard);
